import { BrandLogo } from './BrandLogo'
import { TOPBAR } from '../constants/navigation'
import { CHECKOUT_UI } from '../constants/orders'
import '../styles/checkout-bar.scss'

export function CheckoutBar() {
  return (
    <header className="checkout-bar">
      <div className="container checkout-bar__inner">
        <BrandLogo />
        <p className="checkout-bar__label">
          <strong>{CHECKOUT_UI.barTitle}</strong>
          <span>{CHECKOUT_UI.barLead}</span>
        </p>
        <a href={TOPBAR.phoneHref} className="checkout-bar__phone">
          {TOPBAR.phoneDisplay}
        </a>
      </div>
    </header>
  )
}
